import React, { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Role } from '@bloomays-lib/types.shared';
import { LoaderGlobal } from '@bloomays-lib/ui.shared';
import { useAuthStore, useUserStore } from '../stores';
import { isAuth0TokenRefreshError } from '@bloomays-lib/common.auth/browser';
interface ProtectedRouteProps {
  Component: ComponentType;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ Component }: ProtectedRouteProps): React.JSX.Element => {
  const auth = useAuthStore((state) => state.auth);
  const bloomaysUser = useUserStore((state) => state.user)?.bloomer;
  const authRoles = auth?.user?.roles || [];
  const authUser = auth?.user;
  if (!auth?.isAuthenticated) {
    if (auth?.error && isAuth0TokenRefreshError(auth.error) && auth?.logout) {
      auth?.logout();
      return (<LoaderGlobal waitingText="Session expirée, redirection vers la connexion..." />) as React.JSX.Element;
    }
    auth?.loginWithRedirect({
      appState: { returnTo: `${window.location.pathname}${window.location.search}` },
    });
    return (<LoaderGlobal waitingText="Redirection vers l'authentification" />) as React.JSX.Element;
  }

  if (authUser?.roles?.includes(Role.Anonymous)) {
    return (<Component />) as React.JSX.Element;
  }
  if (auth?.isAuthenticated && authUser?.email_verified === false) {
    return (<Navigate to="/forbidden/norole" />) as React.JSX.Element;
  }

  if (auth?.isAuthenticated && authRoles.length === 1 && authRoles.includes(Role.Bloomer) && !bloomaysUser) {
    return (<Navigate to="/forbidden/notrecognized" />) as React.JSX.Element;
  }

  if (bloomaysUser?.invitation) {
    if (
      bloomaysUser.invitation?.status !== 'done' &&
      !(window.location.href.indexOf(`${bloomaysUser.invitation.token}`) > -1)
    ) {
      return (<Navigate to={`/invite/${bloomaysUser.invitation.token}`} />) as React.JSX.Element;
    }
  }

  const ComponentAuthenticate = withAuthenticationRequired(Component, {
    onRedirecting: () => (<LoaderGlobal waitingText="Redirection vers l'authentification" />) as React.JSX.Element,
  });
  return (<ComponentAuthenticate />) as React.JSX.Element;
};
export default ProtectedRoute;
